module.exports = __webpack_public_path__ + "img/3.9fcf2aa7.jpg";